export default "<article>\n    <img [src]=\"data.deviceInfo.LastScreenshot | safeImage\">\n</article>"